import { toast } from "react-toastify";


export const validateForm = (schema, data) => {
    const result = schema.safeParse(data);

    if (!result.success) {
        const firstError = result.error.errors?.[0]?.message || "Validation failed";
        toast.error(firstError);
        return null;
    }

    return result.data;
};
